<template>
  <pt-obs-department-table class="pt-obs-department-table__withData" @getTableData="getTableData" :tableLabels="tableLabels" :tableData="tableData"
  :pageSize="pageSize" :totalNumber="totalNumber" v-loading="loading" ref="table">
  <slot/>
  </pt-obs-department-table>
</template>

<script>
import PtObsDepartmentTable from './index'
export default {
  name: 'pt-obs-department-table__withData',
  components: {
    'pt-obs-department-table': PtObsDepartmentTable
  },
  props: {
    tableLabels: Array,
    pageSize: {
      type: Number,
      default: 10
    },
    paramsData: Object,
    isFromRouter: Boolean
  },
  data () {
    return {
      tableData: [],
      totalNumber: 0,
      loading: false
    }
  },
  watch: {
    paramsData: {
      handler: function (val) {
        this.getTableData(0)
      },
      deep: true
    }
  },
  methods: {
    getTableData (page, next) {
      let data = {
        pageable: {
          page: page,
          size: this.pageSize
        },
        ...this.paramsData,
        type: 'OBSTETRICS'
      }
      if (!next) {
        this.loading = true
      }
      this.$store.dispatch('getAnswerPageByQuery', data).then(res => {
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        if (next) {
          next(res.data)
        }
        this.loading = false
      }).catch(err => {
        this.$refs.table.showReTry()
        this.loading = false
        this.$message.error(err || '获取产科问答列表失败')
      })
    }
  }
}
</script>
